import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { FinanceEntityIdSchema } from '../finance/finance-entity-id.ts'
import { NameSchema } from '../property.models.ts'

export const BillingAddressIdSchema = z.string().brand('billing-address-id')
export type BillingAddressId = ZodSimplify<typeof BillingAddressIdSchema>

export const BillingAddressId = (value: string = generateRandomString(16)) => {
  return BillingAddressIdSchema.parse(value)
}

export const AddressLineSchema = z.string()
export const CitySchema = z.string()
export const StateSchema = z.string()
export const ZipSchema = z.string()

export const BillingAddressDomainSelectModelSchema = z.object({
  billingAddressId: BillingAddressIdSchema,
  financeEntityId: FinanceEntityIdSchema,
  companyName: NameSchema.optional(),
  firstName: NameSchema,
  lastName: NameSchema,
  address1: AddressLineSchema,
  address2: AddressLineSchema.optional(),
  city: CitySchema,
  state: StateSchema,
  zip: ZipSchema,
})

export type BillingAddressDomainSelectModel = ZodSimplify<
  typeof BillingAddressDomainSelectModelSchema
>

export const BillingAddressDomainInsertModelSchema =
  BillingAddressDomainSelectModelSchema.omit({
    billingAddressId: true,
  })

export type BillingAddressDomainInsertModel = ZodSimplify<
  typeof BillingAddressDomainInsertModelSchema
>

export const BillingAddressDomainUpdateModelSchema =
  BillingAddressDomainSelectModelSchema
